import { startOfDay } from "date-fns";
import { sameDateInUTC } from "../datetime";

export const isBeforeOrEqual = (a: Date, b: Date) =>
  startOfDay(sameDateInUTC(a)) <= startOfDay(sameDateInUTC(b));

export const isAfterOrEqual = (a: Date, b: Date) =>
  startOfDay(sameDateInUTC(a)) >= startOfDay(sameDateInUTC(b));
